import { IllustratedRouteLayout, type ResponsiveDevice } from "@src/common/IllustratedRouteLayout";
import { BodyText, HeadingDiv } from "@src/common/styled-components";
import { MEDIA_QUERIES } from "@src/constants/media-queries";
import { useMediaQuery } from "@uhg-abyss/web/hooks/useMediaQuery";

type PortalRegistrationOutcomeProps = {
  outcome: "completed" | "fallback";
};

export const PortalRegistrationOutcome = ({ outcome }: PortalRegistrationOutcomeProps) => {
  const completed = outcome === "completed";
  const isMobile = useMediaQuery(MEDIA_QUERIES.mobileMax);
  const isTablet = useMediaQuery(MEDIA_QUERIES.tabletMax);
  const device: ResponsiveDevice = isMobile ? "mobile" : isTablet ? "tablet" : "desktop";

  return (
    <IllustratedRouteLayout metaTitle="Patient portal registration" device={device}>
      <HeadingDiv device={device}>
        {completed
          ? "Your patient portal is ready"
          : "We couldn't confirm your patient portal status"}
      </HeadingDiv>
      <BodyText device={device} mobileBrandColor>
        {completed
          ? "Thank you for creating your patient portal! Look for an email from us with important info about your upcoming visit and what to expect next."
          : "Your appointment is still confirmed. If you receive a portal invitation email, follow its instructions to finish setup. Contact us if you need help."}
      </BodyText>
    </IllustratedRouteLayout>
  );
};
